var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 720 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #FFFFFF;\n      }\n\n      .cls-2 {\n        fill: #FFFFFF;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.05,458.07l18.71-13.58c28.83-20.92,52.06-48.61,67.64-80.65l62.34-128.18c14.21-29.21,43.84-47.75,76.31-47.75h72.16,0c-16.49,15.14-36.93,25.32-58.96,29.32-28.31,5.14-56.1,9.64-74.75,59.04l-56.17,115.81c-15.37,31.69-44.85,54.23-79.46,60.75l-27.82,5.24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207.06,513.03h220.12c36.56,0,68.75-14.48,79.04-35.56l5.56-11.39h0c-22.95,10.75-51.23,16.59-80.33,16.59h-172.3l-52.09,30.36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.95,513.32l2.93-3.58c12.5-15.27,29.27-26.46,48.17-32.13l19.4-5.82c47.42-14.23,86.72-47.64,108.38-92.16l40.52-83.25c.4-.83.82-1.65,1.25-2.46,12.2-23.03,35.6-37.98,61.53-40.56l6.05-.6h0c-15.14,13.09-27.19,29.37-35.28,47.68l-43.19,97.69c-24.35,55.09-75.03,94.03-134.54,103.37l-75.22,11.81Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLLogo);
export default __webpack_public_path__ + "static/media/L_logo.50acc4c7fea77f8a4355ee9271799920.svg";
export { ForwardRef as ReactComponent };